export default __webpack_public_path__ + "static/BackgroundSwooshRed-f44bc517151550546f0815aa1e9a8305.png";